import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { useAPI } from "../api/useAPI";
import { useCallback, useState } from "react";
import { THEME_COLOR_SCHEME } from "../utils/theme";
import { YouthKidSearch } from "../youth-kid/YouthKidSearch";
import { useAPIQuery } from "../api/useAPIQuery";
import { useToastOnAPIError } from "../api/useToastOnAPIError";
import { useOnAPISuccess } from "../api/useOnAPISuccess";

interface TeamAddYouthKidModalProps {
  isOpen: boolean;
  onClose: () => void;
  teamId: number;
  onSuccess: () => void;
}

export const TeamAddYouthKidModal = ({
  isOpen,
  onClose,
  teamId,
  onSuccess,
}: TeamAddYouthKidModalProps) => {
  const [selectedYouthKidId, setSelectedYouthKidId] = useState<number | null>(
    null
  );
  const api = useAPI();
  const { data, state, error, query } = useAPIQuery<"youthKidPut">({
    apiCall: api.youthKidPut,
  });
  useToastOnAPIError({ title: "Unable to add youth kid to team", error });
  useOnAPISuccess<"youthKidPut">({
    data,
    state,
    onSuccess,
  });

  const onClick = useCallback(() => {
    if (!selectedYouthKidId) {
      return;
    }
    query({
      id: selectedYouthKidId,
      teamId,
    });
  }, [query, selectedYouthKidId, teamId]);
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={"xl"}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add youth kid</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <YouthKidSearch
            selectedYouthKidId={selectedYouthKidId}
            setSelectedYouthKidId={setSelectedYouthKidId}
          />
        </ModalBody>
        <ModalFooter>
          <Button mr={3} variant={"outline"} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme={THEME_COLOR_SCHEME}
            isDisabled={selectedYouthKidId === null}
            onClick={onClick}
          >
            Add youth kid
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
